import {del, get, post, put} from "../helpers/api_helper"
import {ITrafficOrdersResponse} from "../store/trafficManagement/types";

export const TrafficOrderService = {

    getTrafficOrders: async (params?: any): Promise<ITrafficOrdersResponse> => {
        return get(`/traffic-orders`, {params: params})
    },
    getTrafficOrdersWaiting: async (params?: any): Promise<ITrafficOrdersResponse> => {
        return get(`/traffic-orders/waiting`, {params: params})
    },
    getTrafficOrdersNotActive: async (params?: any): Promise<ITrafficOrdersResponse> => {
        return get(`/traffic-orders/not_active`, {params: params});
    },

    // GET BY CRM_ID
    getTrafficOrdersByCrmId: async (crmId: number, params?: any) => {
        return get(`/traffic-orders/crm/${crmId}`, {params: params})
    },
    getTrafficOrdersByCrmIdWaiting: async (crmId: number, params?: any) => {
        return get(`/traffic-orders/crm/${crmId}/waiting`, {params: params})
    },
    getTrafficOrdersByCrmIdNotActive: async (crmId: number, params?: any) => {
        return get(`/traffic-orders/crm/${crmId}/not_active`, {params: params});
    },

    getTrafficOrder: async (id: number) => {
        return get(`/traffic-orders/${id}`)
    },

    getStatusTrafficOrder: async (id: number, date: string) => {
        return get(`/traffic-orders/${id}/get_status`, {
            params: {date},
        });
    },

    fetchStatistic: async (data: any) => {
        return post('/traffic-orders/statistic', data)
    },

    createTrafficOrder: async (data: any) => {
        return post('/traffic-orders', data)
    },

    getResponsibilityTrafficOrder: async (id: number) => {
        return get(`/traffic-orders/${id}/responsibility`)
    },

    assignTrafficOrder: async (data: any, id: number) => {
        return post(`/traffic-orders/${id}/responsibility`, data)
    },

    getBrokerTrafficOrder: async (id: number) => {
        return get(`/traffic-orders/${id}/broker`)
    },

    updateBrokerTrafficOrder: async (data: any, id: number) => {
        return post(`/traffic-orders/${id}/broker`, data)
    },

    updateStatusTrafficOrder: async (data: any, id: number) => {
        return post(`/traffic-orders/${id}/status`, data)
    },

    updateTrafficOrder: async (id: number, data: any) => {
        return put(`/traffic-orders/${id}`, data)
    },

    pinnedTrafficOrder: async (id: number) => {
        return post(`/traffic-orders/${id}/toggle-pin`, {})
    },

}